import { useState, useEffect, useCallback, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import api, { ehAdministrador } from '../services/api'
import CargaNaturezaJuridicaModal from '../components/CargaNaturezaJuridicaModal'

interface NaturezaJuridica {
  codigo: number; codigo_fmt: string; descricao: string; grupo: number; grupo_des: string
  tp_ente_gov: number | null; resolve_df: boolean; confirmar: boolean
}
interface NatjurCliente { natjur_codigo: string; tp_ente_gov: string; ente_manual: boolean; fonte: string | null; indisponivel?: boolean }
const natjurVazio: NatjurCliente = { natjur_codigo: '', tp_ente_gov: '', ente_manual: false, fonte: null }
// tpEnteGov do gCompraGov (NT CT-e 2025.001)
const TP_ENTE_GOV: Record<string, string> = { '1': 'União', '2': 'Estado', '3': 'Distrito Federal', '4': 'Município', '5': 'Consórcio Público', '6': 'Comitê Gestor do IBS' }

function IconPencil() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
  )
}
function IconDoc() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2.8h9.5L19 6.3V21a0.8 0.8 0 0 1-0.8 0.8H6a0.8 0.8 0 0 1-0.8-0.8V3.6A0.8 0.8 0 0 1 6 2.8Z" />
      <path d="M8.3 9h7.4M8.3 12.3h7.4M8.3 15.6h4.4" />
    </svg>
  )
}
function IconTrash() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 6h18" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
    </svg>
  )
}

interface Cliente {
  cli_cod: string; cli_mat: string; cli_nom: string; cli_fan: string
  cli_fj: string; cli_ins: string; cli_est: string; cli_contri: string
  cli_insmun: string; cli_tipemp: string
  end_tel: string; end_email: string; end_logradouro: string
  end_numero: string; end_bairro: string; end_cep: string
  end_obs: string; end_cidade: string; end_uf: string
  bloqueado: boolean
}

const UFS = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO']

const TIPOS_CADASTRO = [
  { value: 'todos', label: 'Todos' },
  { value: 'C', label: 'Cliente' },
  { value: 'F', label: 'Fornecedor' },
  { value: 'A', label: 'Ambos' },
  { value: 'L', label: 'Provisório' },
  { value: 'M', label: 'Prop/Mot' },
  { value: 'V', label: 'Age/Rep/Ven' },
  { value: 'G', label: 'Guia Turismo' },
  { value: 'H', label: 'Hotel' },
]

const formVazio = {
  cli_mat: '', cli_fj: 'J', cli_nom: '', cli_fan: '',
  cli_contri: 'N', cli_ins: '', cli_est: '', cli_insmun: '', cli_tipemp: ' ',
  logradouro: '', numero: '', complemento: '', bairro: '',
  cep: '', cidade: '', endUf: '', tel1: '', tel2: '', email: '', obs: '',
}

const adVazio = {
  // Compras
  cmp_memoriza: '1', cmp_conta: '', cmp_conta_des: '',
  cmp_nat: '', cmp_nat_cdf: '', cmp_nat_des: '',
  cmp_aplicacao: '', cmp_aplicacao_des: '',
  // Vendas
  vnd_conta: '', vnd_conta_des: '',
  vnd_nat_mun: '', vnd_nat_mun_cdf: '', vnd_nat_mun_des: '',
  vnd_nat_intermun: '', vnd_nat_intermun_cdf: '', vnd_nat_intermun_des: '',
  vnd_nat_interesta: '', vnd_nat_interesta_cdf: '', vnd_nat_interesta_des: '',
  vnd_cod_obs: '', vnd_cod_obs_des: '',
  vnd_cond_pgto: '', vnd_cond_pgto_des: '',
  // Documentação
  doc_nascimento: '', doc_rg: '',
  doc_carteira: '',
  doc_expedicao: '', doc_orgao: '', doc_rntrc: '',
  // E-mails
  eml_01: '', eml_02: '', eml_03: '', eml_04: '',
  eml_copia2: '', eml_copia3: '', eml_copia4: '',
  // Bloqueio
  blq_data: '', blq_motivo: '',
}

const bcoVazio = {
  bco_seq: '1',
  bco_codigo: '', bco_codigo_des: '',
  bco_agencia: '', bco_agencia_dv: '',
  bco_conta: '', bco_conta_dv: '', bco_dac: '',
  bco_tipo: 'CC',
  bco_favorecido_doc: '', bco_favorecido_nome: '',
  bco_cidade: '', bco_uf: '',
  bco_conjunta: 'N',
  bco_forma_pagamento: 'N',
  bco_preferencial: 'S',
}

const porVazio = {
  por_codigo: '', por_codigo_des: '',
  por_preferencial: 'N',
}

type FormState = typeof formVazio
type AdState   = typeof adVazio
type BcoState  = typeof bcoVazio
type PorState  = typeof porVazio
type AbaAd     = 'compras' | 'vendas' | 'documentacao' | 'emails' | 'bloqueio'

const SUB_ABAS: { key: AbaAd; label: string }[] = [
  { key: 'compras',      label: 'Compras'      },
  { key: 'vendas',       label: 'Vendas'        },
  { key: 'documentacao', label: 'Documentação'  },
  { key: 'emails',       label: 'E-mail(s)'     },
  { key: 'bloqueio',     label: 'Bloqueio'      },
]

// Nome da tela correspondente no ERP legado (GeneXus), por aba do cadastro.
const CODIGOS_ABA_CLIENTE: Record<'dados' | 'endereco' | 'adicionais' | 'bancarias' | 'portadores', string | undefined> = {
  dados: 'TCLICAD',
  endereco: 'TCLIEND',
  adicionais: 'TCLIFRO',
  bancarias: 'TCLICTB',
  portadores: 'TCLIPOR',
}

function Row({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.6rem' }}>
      <span style={{ width: 160, fontSize: '0.8rem', color: '#374151', flexShrink: 0 }}>{label}</span>
      {children}
    </div>
  )
}

function Inp({ value, onChange, onBlurLookup, style, placeholder }: { value: string; onChange: (v: string) => void; onBlurLookup?: () => void; style?: React.CSSProperties; placeholder?: string }) {
  return <input className="input" value={value} onChange={e => onChange(e.target.value)} onBlur={onBlurLookup}
    style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', ...style }} placeholder={placeholder} />
}

function InpData({ value, onChange, style }: { value: string; onChange: (v: string) => void; style?: React.CSSProperties }) {
  return <input type="date" className="input" value={value} onChange={e => onChange(e.target.value)}
    style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', ...style }} />
}

function Des({ value }: { value: string }) {
  if (!value) return <span style={{ fontSize: '0.78rem', color: '#9ca3af', flex: 1 }}>—</span>
  return (
    <span style={{
      fontSize: '0.8rem', fontWeight: 600, color: '#1a6ea8',
      background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 4,
      padding: '0.3rem 0.6rem', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
    }}>{value}</span>
  )
}

function BtnBuscar({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" onClick={onClick} title="Buscar..."
      style={{
        border: '1px solid #d1d5db', background: '#fff', borderRadius: 4,
        width: 30, height: 30, flexShrink: 0, cursor: 'pointer', fontSize: '0.9rem',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>🔍</button>
  )
}

function SeletorModal({ titulo, endpoint, codigoKey, descKey, extraKey, extraLabel, onSelecionar, onFechar }: {
  titulo: string; endpoint: string; codigoKey: string; descKey: string
  extraKey?: string; extraLabel?: string
  onSelecionar: (codigo: string, descricao: string, extra?: string) => void; onFechar: () => void
}) {
  const [lista, setLista]         = useState<Record<string, any>[]>([])
  const [filtro, setFiltro]       = useState('')
  const [carregando, setCarregando] = useState(true)

  useEffect(() => {
    api.get(endpoint).then(r => setLista(r.data)).catch(() => setLista([])).finally(() => setCarregando(false))
  }, [endpoint])

  const f = filtro.trim().toUpperCase()
  const filtrada = f
    ? lista.filter(item =>
        String(item[codigoKey]).toUpperCase().includes(f) ||
        String(item[descKey]).toUpperCase().includes(f) ||
        (extraKey && String(item[extraKey]).toUpperCase().includes(f)))
    : lista

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onFechar()}>
      <div className="modal-box" style={{ maxWidth: 480, maxHeight: '80vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{titulo}</h2>
          <button className="modal-fechar" onClick={onFechar}>✕</button>
        </div>
        <div style={{ padding: '0.75rem 1rem 0' }}>
          <input autoFocus placeholder="Filtrar por código ou nome..." value={filtro}
            onChange={e => setFiltro(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', fontSize: '0.85rem', padding: '0.45rem 0.6rem', border: '1px solid #d1d5db', borderRadius: 4 }} />
        </div>
        <div style={{ overflowY: 'auto', flex: 1, padding: '0.5rem 1rem 1rem', marginTop: '0.5rem' }}>
          {carregando && <div style={{ textAlign: 'center', color: '#6b7280', padding: '1rem' }}>Carregando...</div>}
          {!carregando && filtrada.length === 0 && <div style={{ textAlign: 'center', color: '#6b7280', padding: '1rem' }}>Nenhum registro encontrado.</div>}
          {filtrada.map(item => (
            <div key={item[codigoKey]}
              onClick={() => onSelecionar(String(item[codigoKey]).trim(), String(item[descKey]).trim(), extraKey ? String(item[extraKey]).trim() : undefined)}
              style={{ display: 'flex', gap: '0.75rem', padding: '0.5rem 0.6rem', cursor: 'pointer', borderRadius: 4, fontSize: '0.85rem' }}
              onMouseEnter={e => (e.currentTarget.style.background = '#f3f4f6')}
              onMouseLeave={e => (e.currentTarget.style.background = '')}>
              <span style={{ fontFamily: 'monospace', fontWeight: 700, color: '#1a6ea8', minWidth: 60 }}>{item[codigoKey]}</span>
              {extraKey && (
                <span style={{ fontFamily: 'monospace', fontWeight: 700, color: '#92400e', background: '#fef3c7', borderRadius: 3, padding: '0 0.35rem', minWidth: 44, textAlign: 'center' }}
                  title={extraLabel}>{item[extraKey]}</span>
              )}
              <span style={{ color: '#374151' }}>{item[descKey]}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default function CadastroClientes() {
  const [searchParams] = useSearchParams()
  const [lista, setLista]           = useState<Cliente[]>([])
  const [busca, setBusca]           = useState('')
  const [carregando, setCarregando] = useState(false)
  const [modal, setModal]           = useState<false | 'novo' | string>(false)
  const [aba, setAba]               = useState<'dados' | 'endereco' | 'adicionais' | 'bancarias' | 'portadores'>('dados')
  const [abaAd, setAbaAd]           = useState<AbaAd>('compras')
  const [form, setForm]             = useState<FormState>(formVazio)
  const [ad, setAd]                 = useState<AdState>(adVazio)
  // natureza jurídica / ente governamental (compra governamental do CT-e OS) — gravado à parte em frota.cliente_natjur
  const [naturezasJur, setNaturezasJur] = useState<NaturezaJuridica[]>([])
  const [natjur, setNatjur] = useState<NatjurCliente>(natjurVazio)
  const [cargaNatjurAberta, setCargaNatjurAberta] = useState(false)
  useEffect(() => { api.get('/erp/naturezas-juridicas').then(r => setNaturezasJur(r.data || [])).catch(() => {}) }, [])
  const [bco, setBco]               = useState<BcoState>(bcoVazio)
  const [por, setPor]               = useState<PorState>(porVazio)
  const [salvando, setSalvando]     = useState(false)
  const [erro, setErro]             = useState('')
  const [confirmarExcluir, setConfirmarExcluir] = useState<Cliente | null>(null)
  const [seletorBanco, setSeletorBanco] = useState(false)
  const [seletorPortador, setSeletorPortador] = useState(false)
  const [modalRelatorio, setModalRelatorio] = useState(false)
  const [relTipo, setRelTipo] = useState<'sintetico' | 'analitico'>('sintetico')
  const [relStatus, setRelStatus] = useState<'ativo' | 'baixado' | 'todos'>('todos')
  const [relCadastro, setRelCadastro] = useState('todos')
  const [relCliente, setRelCliente] = useState<Cliente | null>(null)
  const [relFormato, setRelFormato] = useState<'pdf' | 'excel'>('pdf')
  const [seletor, setSeletor] = useState<null | {
    titulo: string; endpoint: string; codigoKey: string; descKey: string
    extraKey?: string; extraLabel?: string
    codCampo: keyof AdState; cdfCampo?: keyof AdState; desCampo: keyof AdState
  }>(null)

  function abrirSeletorConta(codCampo: keyof AdState, desCampo: keyof AdState) {
    setSeletor({ titulo: 'Contas Financeiras', endpoint: '/erp/contas', codigoKey: 'dep_cod', descKey: 'dep_des', codCampo, desCampo })
  }
  function abrirSeletorAplicacao(codCampo: keyof AdState, desCampo: keyof AdState) {
    setSeletor({ titulo: 'Contas de Aplicação', endpoint: '/erp/aplicacoes', codigoKey: 'apl_cod', descKey: 'apl_des', codCampo, desCampo })
  }
  function abrirSeletorNatureza(codCampo: keyof AdState, cdfCampo: keyof AdState, desCampo: keyof AdState) {
    setSeletor({ titulo: 'Naturezas de Operação', endpoint: '/erp/naturezasoperacao', codigoKey: 'tno_cod', descKey: 'tno_des', extraKey: 'tno_cdf', extraLabel: 'CFOP', codCampo, cdfCampo, desCampo })
  }
  function abrirSeletorObservacao(codCampo: keyof AdState, desCampo: keyof AdState) {
    setSeletor({ titulo: 'Observações Cadastradas', endpoint: '/erp/observacoes', codigoKey: 'cadinfcod', descKey: 'cadinfdes', codCampo, desCampo })
  }
  function abrirSeletorCondPgto(codCampo: keyof AdState, desCampo: keyof AdState) {
    setSeletor({ titulo: 'Condições de Pagamento', endpoint: '/condicao-pagamento', codigoKey: 'tcv_cod', descKey: 'tcv_des', codCampo, desCampo })
  }

  const carregar = useCallback(async () => {
    if (busca.trim().length < 2) { setLista([]); return }
    setCarregando(true)
    try {
      const r = await api.get('/erp/clientes/lista', { params: { busca } })
      setLista(r.data)
    } catch { setLista([]) }
    finally { setCarregando(false) }
  }, [busca])

  useEffect(() => { carregar() }, [carregar])

  function abrirNovo() {
    setForm(formVazio); setAd(adVazio); setBco(bcoVazio); setPor(porVazio); setNatjur(natjurVazio); setAvisoCnpj('')
    setAba('dados'); setAbaAd('compras'); setErro('')
    setModal('novo')
  }

  function abrirEditar(c: Cliente) {
    const [tel1, tel2] = (c.end_tel || '').split(' / ')
    setForm({
      cli_mat: c.cli_mat, cli_fj: c.cli_fj || 'J',
      cli_nom: c.cli_nom, cli_fan: c.cli_fan || '',
      cli_contri: c.cli_contri || 'N', cli_ins: c.cli_ins || '',
      cli_est: c.cli_est || '', cli_insmun: c.cli_insmun || '',
      cli_tipemp: c.cli_tipemp || ' ',
      logradouro: c.end_logradouro || '', numero: c.end_numero || '',
      complemento: '', bairro: c.end_bairro || '',
      cep: c.end_cep || '', cidade: c.end_cidade || '',
      endUf: c.end_uf || '', tel1: tel1 || '', tel2: tel2 || '',
      email: c.end_email || '', obs: c.end_obs || '',
    })
    setAd(adVazio)
    setBco({ ...bcoVazio, bco_favorecido_doc: c.cli_mat, bco_favorecido_nome: c.cli_nom })
    setPor(porVazio)
    setAba('dados'); setAbaAd('compras'); setErro('')
    // modal guarda o cli_cod: vários cadastros podem ter o mesmo CNPJ
    setModal(c.cli_cod)
    api.get(`/erp/clientes/${c.cli_mat}/adicionais`)
      .then(r => setAd(p => ({ ...p, ...r.data })))
      .catch(() => {})
    setNatjur(natjurVazio); setAvisoCnpj('')
    api.get(`/erp/clientes-natjur/${c.cli_mat}`)
      .then(r => setNatjur({ ...natjurVazio, ...r.data, natjur_codigo: r.data?.natjur_codigo ? String(r.data.natjur_codigo) : '', tp_ente_gov: r.data?.tp_ente_gov ? String(r.data.tp_ente_gov) : '' }))
      .catch(() => {})
    api.get(`/erp/clientes/${c.cli_cod}/contabancaria`)
      .then(r => { if (r.data && r.data.bco_seq) setBco(p => ({ ...p, ...r.data })) })
      .catch(() => {})
    api.get(`/erp/clientes/${c.cli_cod}/portador`)
      .then(r => { if (r.data && r.data.por_codigo) setPor(p => ({ ...p, ...r.data })) })
      .catch(() => {})
  }

  // Deep-link vindo de outra tela (ex: Lançamento de Notas, depois de auto-
  // cadastrar um fornecedor na importação de XML) — abre direto em modo edição.
  const editarUrlDisparado = useRef(false)
  useEffect(() => {
    const cnpjEditar = searchParams.get('editar')
    if (!cnpjEditar || editarUrlDisparado.current) return
    editarUrlDisparado.current = true
    api.get('/erp/clientes/lista', { params: { busca: cnpjEditar } }).then(r => {
      const achado = (r.data || []).find((c: Cliente) => c.cli_mat === cnpjEditar.replace(/\D/g, ''))
      if (achado) abrirEditar(achado)
    }).catch(() => {})
  }, [searchParams])

  function f(field: keyof FormState, value: string) { setForm(p => ({ ...p, [field]: value })) }
  function a(field: keyof AdState, value: string | boolean) { setAd(p => ({ ...p, [field]: value })) }
  function bc(field: keyof BcoState, value: string) { setBco(p => ({ ...p, [field]: value })) }

  async function buscarBanco(cod: string) {
    const c = cod.trim()
    if (!c) return
    try {
      const r = await api.get('/erp/bancos', { params: { busca: c } })
      const achado = r.data.find((x: any) => String(x.ban_cod) === c)
      if (achado) bc('bco_codigo_des', achado.ban_des.trim())
    } catch {}
  }

  function pc(field: keyof PorState, value: string) { setPor(p => ({ ...p, [field]: value })) }

  async function buscarPortador(cod: string) {
    const c = cod.trim()
    if (!c) return
    try {
      const r = await api.get('/erp/portadores', { params: { busca: c } })
      const achado = r.data.find((x: any) => String(x.por_cod) === c)
      if (achado) pc('por_codigo_des', achado.por_des.trim())
    } catch {}
  }

  async function buscarConta(cod: string, campoDes: keyof AdState) {
    const c = cod.trim()
    if (!c) return
    try {
      const r = await api.get('/erp/contas', { params: { busca: c } })
      const achada = r.data.find((x: any) => x.dep_cod.trim() === c)
      if (achada) a(campoDes, achada.dep_des.trim())
    } catch {}
  }

  async function buscarNaturezaPorCod(cod: string, cdfCampo: keyof AdState, desCampo: keyof AdState) {
    const c = cod.trim()
    if (!c) return
    try {
      const r = await api.get('/erp/naturezasoperacao', { params: { busca: c } })
      const achada = r.data.find((x: any) => String(x.tno_cod) === c)
      if (achada) {
        a(cdfCampo, String(achada.tno_cdf))
        a(desCampo, achada.tno_des.trim())
      }
    } catch {}
  }

  async function buscarNaturezaPorCdf(cdf: string, codCampo: keyof AdState, desCampo: keyof AdState) {
    const c = cdf.trim()
    if (!c) return
    try {
      const r = await api.get('/erp/naturezasoperacao', { params: { busca: c } })
      const achada = r.data.find((x: any) => String(x.tno_cdf) === c)
      if (achada) {
        a(codCampo, String(achada.tno_cod))
        a(desCampo, achada.tno_des.trim())
      }
    } catch {}
  }

  async function buscarAplicacao(cod: string, campoDes: keyof AdState) {
    const c = cod.trim()
    if (!c) return
    try {
      const r = await api.get('/erp/aplicacoes', { params: { busca: c } })
      const achada = r.data.find((x: any) => x.apl_cod.trim() === c)
      if (achada) a(campoDes, achada.apl_des.trim())
    } catch {}
  }

  async function buscarObservacao(cod: string, campoDes: keyof AdState) {
    const c = cod.trim()
    if (!c) return
    try {
      const r = await api.get('/erp/observacoes', { params: { busca: c } })
      const achada = r.data.find((x: any) => x.cadinfcod.trim() === c)
      if (achada) a(campoDes, (achada.cadinfdes || '').trim())
    } catch {}
  }

  async function buscarCondPgto(cod: string, campoDes: keyof AdState) {
    const c = cod.trim()
    if (!c) return
    try {
      const r = await api.get('/condicao-pagamento', { params: { busca: c } })
      const achada = r.data.find((x: any) => String(x.tcv_cod) === c)
      if (achada) a(campoDes, (achada.tcv_des || '').trim())
    } catch {}
  }

  function formatarDoc(v: string) {
    const n = v.replace(/\D/g, '')
    if (form.cli_fj === 'J') return n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5')
    return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4')
  }

  function handleDocChange(v: string) {
    const doc = v.replace(/\D/g, '').slice(0, form.cli_fj === 'J' ? 14 : 11)
    f('cli_mat', doc)
    // cliente novo PJ: ao completar o CNPJ já busca os dados na Receita
    if (modal === 'novo' && form.cli_fj === 'J' && doc.length === 14 && doc !== form.cli_mat) consultarCnpj(doc)
  }

  // BrasilAPI: preenche só os campos vazios (nunca sobrescreve o que já está no cadastro) + natureza jurídica
  const [consultandoCnpj, setConsultandoCnpj] = useState(false)
  const [avisoCnpj, setAvisoCnpj] = useState('')
  async function consultarCnpj(docInformado?: string) {
    const doc = (docInformado ?? form.cli_mat).replace(/\D/g, '')
    if (doc.length !== 14) { setAvisoCnpj('Informe um CNPJ com 14 dígitos.'); return }
    setConsultandoCnpj(true); setAvisoCnpj('')
    try {
      const d = (await api.get(`/erp/cnpj/${doc}/consulta`)).data
      const fone = String(d.telefone || '')
      setForm(p => ({
        ...p,
        cli_nom: p.cli_nom || d.razaoSocial.toUpperCase(),
        cli_fan: p.cli_fan || (d.nomeFantasia || d.razaoSocial).toUpperCase(),
        cli_est: p.cli_est || d.uf, endUf: p.endUf || d.uf,
        logradouro: p.logradouro || d.logradouro, numero: p.numero || d.numero, bairro: p.bairro || d.bairro,
        cep: p.cep || (d.cep ? d.cep.replace(/(\d{5})(\d)/, '$1-$2') : ''),
        cidade: p.cidade || d.municipio,
        tel1: p.tel1 || (fone.length >= 10 ? `(${fone.slice(0, 2)}) ${fone.slice(2)}` : fone),
        email: p.email || d.email,
      }))
      const natOk = naturezasJur.some(n => n.codigo === d.naturezaCodigo)
      if (natOk) setNatjur(p => ({ ...p, natjur_codigo: String(d.naturezaCodigo), fonte: 'BRASILAPI', ente_manual: false, tp_ente_gov: '' }))
      setAvisoCnpj(`Receita: ${d.razaoSocial} — ${d.situacao || 'situação não informada'}` +
        (d.naturezaCodigo ? ` · Natureza ${d.naturezaDescricao}` : '') +
        (d.tpEnteGovSugerido ? ` · ENTE GOVERNAMENTAL (${TP_ENTE_GOV[String(d.tpEnteGovSugerido)]})` : '') +
        (d.situacao && d.situacao !== 'ATIVA' ? ' ⚠ CNPJ não está ativo!' : ''))
    } catch (e: any) {
      setAvisoCnpj(e?.response?.data?.error || 'Não foi possível consultar o CNPJ.')
    } finally {
      setConsultandoCnpj(false)
    }
  }

  async function buscarCep(cep: string) {
    const c = cep.replace(/\D/g, '')
    if (c.length !== 8) return
    try {
      const r = await fetch(`https://viacep.com.br/ws/${c}/json/`)
      const d = await r.json()
      if (!d.erro) setForm(p => ({ ...p, logradouro: d.logradouro ?? '', bairro: d.bairro ?? '', cidade: d.localidade ?? '', endUf: d.uf ?? '' }))
    } catch {}
  }

  async function salvar() {
    setErro('')
    if (!form.cli_mat || !form.cli_nom) { setErro('CNPJ/CPF e Nome/Razão Social são obrigatórios.'); setAba('dados'); return }
    setSalvando(true)
    try {
      const payload = {
        cli_mat: form.cli_mat.replace(/\D/g, ''), cli_fj: form.cli_fj,
        cli_nom: form.cli_nom, cli_fan: form.cli_fan || form.cli_nom,
        cli_contri: form.cli_contri, cli_ins: form.cli_ins,
        cli_est: form.cli_est, cli_insmun: form.cli_insmun, cli_tipemp: form.cli_tipemp,
        end_logradouro: form.logradouro, end_numero: form.numero,
        end_bairro: form.bairro, end_cep: form.cep,
        end_cidade: form.cidade, end_uf: form.endUf,
        end_tel: form.tel1 + (form.tel2 ? ` / ${form.tel2}` : ''),
        end_email: form.email, end_obs: form.obs,
        cmp_memoriza: ad.cmp_memoriza, cmp_conta: ad.cmp_conta,
        cmp_nat: ad.cmp_nat, cmp_aplicacao: ad.cmp_aplicacao,
        vnd_conta: ad.vnd_conta,
        vnd_nat_mun: ad.vnd_nat_mun, vnd_nat_intermun: ad.vnd_nat_intermun, vnd_nat_interesta: ad.vnd_nat_interesta,
        vnd_cod_obs: ad.vnd_cod_obs,
        vnd_cond_pgto: ad.vnd_cond_pgto,
        doc_nascimento: ad.doc_nascimento, doc_rg: ad.doc_rg, doc_carteira: ad.doc_carteira,
        doc_expedicao: ad.doc_expedicao, doc_orgao: ad.doc_orgao, doc_rntrc: ad.doc_rntrc,
        eml_01: ad.eml_01, eml_02: ad.eml_02, eml_03: ad.eml_03, eml_04: ad.eml_04,
        eml_copia2: ad.eml_copia2, eml_copia3: ad.eml_copia3, eml_copia4: ad.eml_copia4,
        blq_data: ad.blq_data, blq_motivo: ad.blq_motivo,
        bco_seq: bco.bco_seq, bco_codigo: bco.bco_codigo,
        bco_agencia: bco.bco_agencia, bco_agencia_dv: bco.bco_agencia_dv,
        bco_conta: bco.bco_conta, bco_conta_dv: bco.bco_conta_dv, bco_dac: bco.bco_dac,
        bco_tipo: bco.bco_tipo,
        bco_favorecido_doc: bco.bco_favorecido_doc, bco_favorecido_nome: bco.bco_favorecido_nome,
        bco_cidade: bco.bco_cidade, bco_uf: bco.bco_uf,
        bco_conjunta: bco.bco_conjunta, bco_forma_pagamento: bco.bco_forma_pagamento,
        bco_preferencial: bco.bco_preferencial,
        por_codigo: por.por_codigo, por_preferencial: por.por_preferencial,
      }
      if (modal === 'novo') await api.post('/erp/clientes', payload)
      else await api.put(`/erp/clientes/${payload.cli_mat}`, { ...payload, cli_cod: modal })
      if (form.cli_fj === 'J' && !natjur.indisponivel) {
        try {
          await api.put(`/erp/clientes-natjur/${payload.cli_mat}`, {
            natjur_codigo: natjur.natjur_codigo || null, tp_ente_gov: natjur.tp_ente_gov || null,
            ente_manual: natjur.ente_manual, uf: form.cli_est || form.endUf, fonte: natjur.fonte || 'MANUAL',
          })
        } catch (e: any) {
          setErro(`Cliente salvo, mas a natureza jurídica não: ${e?.response?.data?.error ?? 'erro ao gravar.'}`)
          carregar(); return
        }
      }
      setModal(false); carregar()
    } catch (e: any) {
      setErro(e?.response?.data?.error ?? 'Erro ao salvar.')
    } finally { setSalvando(false) }
  }

  async function excluir(c: Cliente) {
    try {
      // cli_cod: excluir só este cadastro, não todos do mesmo CNPJ
      await api.delete(`/erp/clientes/${c.cli_mat.replace(/\D/g, '')}`, { params: { cod: c.cli_cod } })
      setConfirmarExcluir(null); carregar()
    } catch (e: any) { alert(e?.response?.data?.error ?? 'Erro ao excluir.') }
  }

  function abrirRelatorioCliente(c: Cliente) {
    setRelCliente(c); setRelTipo('analitico')
    setModalRelatorio(true)
  }

  function gerarRelatorio() {
    const params = new URLSearchParams({ tipo: relTipo, status: relStatus, cadastro: relCadastro, formato: relFormato })
    if (relCliente) params.set('mat', relCliente.cli_mat)
    window.open(`/api/erp/relatorios/clientes?${params.toString()}`, '_blank')
    setModalRelatorio(false)
  }

  const inpSm  = { width: 80 }
  const inpMd  = { width: 140 }
  const inpLg  = { width: 220 }
  const inpCod = { width: 70 }

  return (
    <>
      <div className="card">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>Clientes e Fornecedores</h2>
          {ehAdministrador() && (
            <button className="btn btn-sm" onClick={() => setCargaNatjurAberta(true)}
              title="Busca na Receita (BrasilAPI) a natureza jurídica dos clientes PJ já cadastrados"
              style={{ whiteSpace: 'nowrap', color: '#1b3f7b', border: '1px solid #c7d6ea', background: '#eef3f9', fontWeight: 600 }}>
              Natureza Jurídica (Receita)
            </button>
          )}
        </div>
        {cargaNatjurAberta && <CargaNaturezaJuridicaModal onClose={() => setCargaNatjurAberta(false)} />}

        <div className="busca-cliente-wrap" style={{ marginBottom: '1rem' }}>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Nome, nome fantasia ou CNPJ/CPF</label>
            <div className="busca-cliente-row">
              <input type="text" placeholder="Digite para buscar..." value={busca} onChange={e => setBusca(e.target.value)} />
              <button className="btn btn-secondary btn-sm" onClick={() => { setRelCliente(null); setModalRelatorio(true) }} style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                <span style={{ background: '#dc2626', color: '#fff', fontSize: '0.62rem', fontWeight: 700, borderRadius: 3, padding: '0.1rem 0.3rem', lineHeight: 1.4 }}>PDF</span>
                Gerar Relatório
              </button>
              <button className="btn btn-primary btn-sm" onClick={abrirNovo} style={{ whiteSpace: 'nowrap' }}>+ Novo Cliente</button>
            </div>
          </div>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table className="table">
            <thead>
              <tr>
                <th>CNPJ/CPF</th><th>Razão Social</th><th>Fantasia</th>
                <th>Cidade/UF</th><th>Telefone</th><th></th>
              </tr>
            </thead>
            <tbody>
              {carregando && <tr><td colSpan={6} style={{ textAlign: 'center', color: '#6b7280' }}>Carregando...</td></tr>}
              {!carregando && lista.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign: 'center', color: '#6b7280', padding: '2rem' }}>
                  {busca.trim().length < 2 ? 'Digite o nome ou CNPJ/CPF para buscar.' : 'Nenhum registro encontrado.'}
                </td></tr>
              )}
              {lista.map(c => (
                <tr key={c.cli_mat}>
                  <td style={{ fontFamily: 'monospace', fontSize: '0.82rem', whiteSpace: 'nowrap' }}>{c.cli_mat}</td>
                  <td style={{ fontWeight: 600 }}>
                    {c.cli_nom}
                    {c.bloqueado && (
                      <span style={{
                        marginLeft: '0.5rem', fontSize: '0.68rem', fontWeight: 700, color: '#fff',
                        background: '#dc2626', borderRadius: 4, padding: '0.15rem 0.45rem', verticalAlign: 'middle',
                      }}>BLOQUEADO</span>
                    )}
                  </td>
                  <td style={{ fontSize: '0.82rem', color: '#6b7280' }}>{c.cli_fan || '—'}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{c.end_cidade ? `${c.end_cidade}/${c.end_uf}` : '—'}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{c.end_tel || '—'}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <div className="row-actions">
                      <button className="row-action-btn row-action-btn--edit" onClick={() => abrirEditar(c)} title="Editar"><IconPencil /></button>
                      <button className="row-action-btn row-action-btn--report" onClick={() => abrirRelatorioCliente(c)} title="Gerar relatório deste cliente"><IconDoc /></button>
                      <button className="row-action-btn row-action-btn--danger" onClick={() => setConfirmarExcluir(c)} title="Excluir"><IconTrash /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── Modal cadastro ── */}
      {modal !== false && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal-box" style={{ maxWidth: 720 }} onClick={e => e.stopPropagation()}>

            <div className="modal-header" style={{ position: 'relative' }}>
              <h2>{modal === 'novo' ? 'Novo Cadastro' : 'Editar Cadastro'}</h2>
              {CODIGOS_ABA_CLIENTE[aba] && (
                <span style={{
                  position: 'absolute', left: '50%', transform: 'translateX(-50%)',
                  fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)',
                }}>
                  {CODIGOS_ABA_CLIENTE[aba]}
                </span>
              )}
              <button className="modal-fechar" onClick={() => setModal(false)}>✕</button>
            </div>

            <div className="modal-abas">
              {(['dados', 'endereco', 'adicionais', 'bancarias', 'portadores'] as const).map(t => (
                <button key={t} className={`modal-aba${aba === t ? ' modal-aba--ativa' : ''}`} onClick={() => setAba(t)}>
                  {t === 'dados' ? 'Dados Principais' : t === 'endereco' ? 'Endereços' : t === 'adicionais' ? 'Adicionais' : t === 'bancarias' ? 'Contas Bancárias' : 'Portadores'}
                </button>
              ))}
            </div>

            <div className="modal-corpo">

              {/* ── Dados Principais ── */}
              {aba === 'dados' && (
                <div className="form-grid-cad">
                  <div className="field-cad col2">
                    <label>CNPJ / CPF</label>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'stretch' }}>
                      <input value={formatarDoc(form.cli_mat)} onChange={e => handleDocChange(e.target.value)} style={{ flex: 1, minWidth: 0, width: 'auto' }}
                        disabled={modal !== 'novo'} placeholder={form.cli_fj === 'J' ? '00.000.000/0000-00' : '000.000.000-00'} autoFocus />
                      {form.cli_fj === 'J' && (
                        <button type="button" className="btn btn-sm" onClick={() => consultarCnpj()} disabled={consultandoCnpj}
                          title="Busca os dados na Receita (BrasilAPI) e preenche os campos vazios e a natureza jurídica"
                          style={{ flexShrink: 0, whiteSpace: 'nowrap', color: '#1b3f7b', border: '1.5px solid #c7d6ea', background: '#eef3f9', fontWeight: 600, borderRadius: '0.5rem', padding: '0 0.7rem' }}>
                          {consultandoCnpj ? 'Consultando...' : '🔎 Consultar'}
                        </button>
                      )}
                    </div>
                    {avisoCnpj && <span style={{ fontSize: '0.72rem', color: avisoCnpj.startsWith('Receita') ? '#1b3f7b' : '#dc2626' }}>{avisoCnpj}</span>}
                  </div>
                  <div className="field-cad">
                    <label>Natureza</label>
                    <select value={form.cli_fj} onChange={e => { f('cli_fj', e.target.value); f('cli_mat', '') }}>
                      <option value="J">Jurídica</option>
                      <option value="F">Física</option>
                      <option value="E">Estrangeiro</option>
                    </select>
                  </div>
                  <div className="field-cad">
                    <label>Tipo de Cadastro</label>
                    <select defaultValue="C">
                      <option value="C">Cliente</option>
                      <option value="F">Fornecedor</option>
                      <option value="A">Ambos</option>
                    </select>
                  </div>
                  <div className="field-cad col4">
                    <label>Nome / Razão Social <span className="obrig">*</span></label>
                    <input value={form.cli_nom} onChange={e => f('cli_nom', e.target.value.toUpperCase())} placeholder="Nome completo ou razão social" />
                  </div>
                  <div className="field-cad col4">
                    <label>Fantasia</label>
                    <input value={form.cli_fan} onChange={e => f('cli_fan', e.target.value.toUpperCase())} placeholder="Nome fantasia (opcional)" />
                  </div>
                  <div className="field-cad col2">
                    <label>Contribuinte ICMS</label>
                    <select value={form.cli_contri} onChange={e => f('cli_contri', e.target.value)}>
                      <option value="N">Não Contribuinte</option>
                      <option value="S">Contribuinte</option>
                      <option value="C">Comércio</option>
                      <option value="I">Isento</option>
                    </select>
                  </div>
                  <div className="field-cad col2">
                    <label>Inscrição Estadual</label>
                    <input value={form.cli_ins} onChange={e => f('cli_ins', e.target.value)} placeholder="IE" />
                  </div>
                  <div className="field-cad">
                    <label>Estado (UF)</label>
                    <select value={form.cli_est} onChange={e => f('cli_est', e.target.value)}>
                      <option value="">--</option>
                      {UFS.map(u => <option key={u} value={u}>{u}</option>)}
                    </select>
                  </div>
                  <div className="field-cad col2">
                    <label>Inscrição Municipal</label>
                    <input value={form.cli_insmun} onChange={e => f('cli_insmun', e.target.value)} placeholder="IM" />
                  </div>
                  <div className="field-cad">
                    <label>Tipo de Empresa</label>
                    <select value={form.cli_tipemp} onChange={e => f('cli_tipemp', e.target.value)}>
                      <option value=" ">Geral</option>
                      <option value="M">ME</option>
                      <option value="E">EPP</option>
                      <option value="S">Simples Nacional</option>
                    </select>
                  </div>
                </div>
              )}

              {/* ── Endereços ── */}
              {aba === 'endereco' && (
                <div className="form-grid-cad">
                  <div className="field-cad col3">
                    <label>Endereço / Logradouro</label>
                    <input value={form.logradouro} onChange={e => f('logradouro', e.target.value)} placeholder="Rua, Av, etc." />
                  </div>
                  <div className="field-cad">
                    <label>Número</label>
                    <input value={form.numero} onChange={e => f('numero', e.target.value)} placeholder="Nro" />
                  </div>
                  <div className="field-cad col2">
                    <label>Complemento</label>
                    <input value={form.complemento} onChange={e => f('complemento', e.target.value)} placeholder="Sala, apto..." />
                  </div>
                  <div className="field-cad col2">
                    <label>Bairro</label>
                    <input value={form.bairro} onChange={e => f('bairro', e.target.value)} />
                  </div>
                  <div className="field-cad">
                    <label>CEP</label>
                    <input value={form.cep}
                      onChange={e => f('cep', e.target.value.replace(/\D/g, '').replace(/(\d{5})(\d)/, '$1-$2'))}
                      onBlur={e => buscarCep(e.target.value)} placeholder="00000-000" maxLength={9} />
                  </div>
                  <div className="field-cad col2">
                    <label>Cidade</label>
                    <input value={form.cidade} onChange={e => f('cidade', e.target.value)} />
                  </div>
                  <div className="field-cad">
                    <label>Estado (UF)</label>
                    <select value={form.endUf} onChange={e => f('endUf', e.target.value)}>
                      <option value="">--</option>
                      {UFS.map(u => <option key={u} value={u}>{u}</option>)}
                    </select>
                  </div>
                  <div className="field-cad col2">
                    <label>Telefone / Cel</label>
                    <input value={form.tel1} onChange={e => f('tel1', e.target.value)} placeholder="(00) 00000-0000" />
                  </div>
                  <div className="field-cad col2">
                    <label>Telefone 2</label>
                    <input value={form.tel2} onChange={e => f('tel2', e.target.value)} placeholder="(00) 0000-0000" />
                  </div>
                  <div className="field-cad col4">
                    <label>E-mail</label>
                    <input type="email" value={form.email} onChange={e => f('email', e.target.value)} placeholder="email@exemplo.com" />
                  </div>
                  <div className="field-cad col4">
                    <label>Observação</label>
                    <input value={form.obs} onChange={e => f('obs', e.target.value)} />
                  </div>
                  {form.cli_fj === 'J' && (() => {
                    const nat = naturezasJur.find(n => String(n.codigo) === natjur.natjur_codigo)
                    const uf = (form.cli_est || form.endUf || '').toUpperCase()
                    const sugerido = !nat || nat.tp_ente_gov == null || nat.confirmar ? '' : String(nat.resolve_df && uf === 'DF' ? 3 : nat.tp_ente_gov)
                    const enteAtual = natjur.ente_manual ? natjur.tp_ente_gov : sugerido
                    if (natjur.indisponivel || naturezasJur.length === 0) {
                      return <div className="field-cad col4" style={{ fontSize: '0.75rem', color: '#9ca3af' }}>Natureza jurídica indisponível nesta base (migration 050 não aplicada).</div>
                    }
                    return (
                      <>
                        <div className="field-cad col4">
                          <label>Natureza Jurídica</label>
                          <select value={natjur.natjur_codigo} onChange={e => setNatjur(p => ({ ...p, natjur_codigo: e.target.value, fonte: 'MANUAL' }))}>
                            <option value="">-- não informada --</option>
                            {naturezasJur.map(n => <option key={n.codigo} value={String(n.codigo)}>{n.codigo_fmt} - {n.descricao}</option>)}
                          </select>
                        </div>
                        <div className="field-cad col2">
                          <label>Ente Governamental</label>
                          <select value={enteAtual}
                            onChange={e => setNatjur(p => ({ ...p, tp_ente_gov: e.target.value, ente_manual: e.target.value !== sugerido }))}
                            style={enteAtual ? { background: '#eef3f9', borderColor: '#1b3f7b', fontWeight: 600 } : undefined}>
                            <option value="">Não é ente governamental</option>
                            {Object.entries(TP_ENTE_GOV).map(([k, v]) => <option key={k} value={k}>{k} - {v}</option>)}
                          </select>
                          {nat?.confirmar && !natjur.ente_manual && (
                            <span style={{ fontSize: '0.7rem', color: '#b45309' }}>Natureza de direito privado: confirme manualmente se é compra governamental.</span>
                          )}
                          {natjur.ente_manual && <span style={{ fontSize: '0.7rem', color: '#6b7280' }}>Definido manualmente.</span>}
                        </div>
                      </>
                    )
                  })()}
                </div>
              )}

              {/* ── Adicionais ── */}
              {aba === 'adicionais' && (
                <div>
                  {/* Sub-abas */}
                  <div style={{ display: 'flex', borderBottom: '2px solid #e5e7eb', marginBottom: '1.25rem' }}>
                    {SUB_ABAS.map(s => (
                      <button key={s.key} onClick={() => setAbaAd(s.key)}
                        style={{
                          padding: '0.45rem 0.9rem', background: 'none', border: 'none',
                          borderBottom: abaAd === s.key ? '2px solid #f07820' : '2px solid transparent',
                          marginBottom: -2, fontSize: '0.8rem',
                          fontWeight: abaAd === s.key ? 700 : 500,
                          color: abaAd === s.key ? '#1a6ea8' : '#6b7280',
                          cursor: 'pointer', whiteSpace: 'nowrap',
                        }}>
                        {s.label}
                      </button>
                    ))}
                  </div>

                  {/* COMPRAS */}
                  {abaAd === 'compras' && (
                    <div>
                      <Row label="Memoriza/Sugerir:">
                        <select className="input" value={ad.cmp_memoriza} onChange={e => a('cmp_memoriza', e.target.value)} style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', width: 280 }}>
                          <option value="1">1 - Cfe. Parâmetros da Empresa</option>
                          <option value="0">0 - Não Memorizar ou Sugerir</option>
                          <option value="2">2 - Memorizar, Atualizar e Sugerir</option>
                          <option value="3">3 - Memorizar e Sugerir</option>
                          <option value="4">4 - Apenas Sugerir</option>
                        </select>
                      </Row>
                      <Row label="Conta Financeira:">
                        <Inp value={ad.cmp_conta} onChange={v => { a('cmp_conta', v); a('cmp_conta_des', '') }}
                          onBlurLookup={() => buscarConta(ad.cmp_conta, 'cmp_conta_des')} style={inpCod} />
                        <BtnBuscar onClick={() => abrirSeletorConta('cmp_conta', 'cmp_conta_des')} />
                        <Des value={ad.cmp_conta_des} />
                      </Row>
                      <Row label="Nat. de Operação:">
                        <Inp value={ad.cmp_nat} onChange={v => { a('cmp_nat', v); a('cmp_nat_des', '') }}
                          onBlurLookup={() => buscarNaturezaPorCod(ad.cmp_nat, 'cmp_nat_cdf', 'cmp_nat_des')} style={inpCod} placeholder="Código" />
                        <Inp value={ad.cmp_nat_cdf} onChange={v => { a('cmp_nat_cdf', v); a('cmp_nat_des', '') }}
                          onBlurLookup={() => buscarNaturezaPorCdf(ad.cmp_nat_cdf, 'cmp_nat', 'cmp_nat_des')}
                          style={{ ...inpCod, background: '#fef3c7', borderColor: '#f59e0b' }} placeholder="CFOP" />
                        <BtnBuscar onClick={() => abrirSeletorNatureza('cmp_nat', 'cmp_nat_cdf', 'cmp_nat_des')} />
                        <Des value={ad.cmp_nat_des} />
                      </Row>
                      <Row label="Cta. Aplicação:">
                        <Inp value={ad.cmp_aplicacao} onChange={v => { a('cmp_aplicacao', v); a('cmp_aplicacao_des', '') }}
                          onBlurLookup={() => buscarAplicacao(ad.cmp_aplicacao, 'cmp_aplicacao_des')} style={inpCod} />
                        <BtnBuscar onClick={() => abrirSeletorAplicacao('cmp_aplicacao', 'cmp_aplicacao_des')} />
                        <Des value={ad.cmp_aplicacao_des} />
                      </Row>
                    </div>
                  )}

                  {/* VENDAS */}
                  {abaAd === 'vendas' && (
                    <div>
                      <Row label="Conta Financeira:">
                        <Inp value={ad.vnd_conta} onChange={v => { a('vnd_conta', v); a('vnd_conta_des', '') }}
                          onBlurLookup={() => buscarConta(ad.vnd_conta, 'vnd_conta_des')} style={inpCod} />
                        <BtnBuscar onClick={() => abrirSeletorConta('vnd_conta', 'vnd_conta_des')} />
                        <Des value={ad.vnd_conta_des} />
                      </Row>
                      <Row label="Nat.Tr.Municipal:">
                        <Inp value={ad.vnd_nat_mun} onChange={v => { a('vnd_nat_mun', v); a('vnd_nat_mun_des', '') }}
                          onBlurLookup={() => buscarNaturezaPorCod(ad.vnd_nat_mun, 'vnd_nat_mun_cdf', 'vnd_nat_mun_des')} style={inpCod} placeholder="Código" />
                        <Inp value={ad.vnd_nat_mun_cdf} onChange={v => { a('vnd_nat_mun_cdf', v); a('vnd_nat_mun_des', '') }}
                          onBlurLookup={() => buscarNaturezaPorCdf(ad.vnd_nat_mun_cdf, 'vnd_nat_mun', 'vnd_nat_mun_des')}
                          style={{ ...inpCod, background: '#fef3c7', borderColor: '#f59e0b' }} placeholder="CFOP" />
                        <BtnBuscar onClick={() => abrirSeletorNatureza('vnd_nat_mun', 'vnd_nat_mun_cdf', 'vnd_nat_mun_des')} />
                        <Des value={ad.vnd_nat_mun_des} />
                      </Row>
                      <Row label="Nat.Tr.InterMuni:">
                        <Inp value={ad.vnd_nat_intermun} onChange={v => { a('vnd_nat_intermun', v); a('vnd_nat_intermun_des', '') }}
                          onBlurLookup={() => buscarNaturezaPorCod(ad.vnd_nat_intermun, 'vnd_nat_intermun_cdf', 'vnd_nat_intermun_des')} style={inpCod} placeholder="Código" />
                        <Inp value={ad.vnd_nat_intermun_cdf} onChange={v => { a('vnd_nat_intermun_cdf', v); a('vnd_nat_intermun_des', '') }}
                          onBlurLookup={() => buscarNaturezaPorCdf(ad.vnd_nat_intermun_cdf, 'vnd_nat_intermun', 'vnd_nat_intermun_des')}
                          style={{ ...inpCod, background: '#fef3c7', borderColor: '#f59e0b' }} placeholder="CFOP" />
                        <BtnBuscar onClick={() => abrirSeletorNatureza('vnd_nat_intermun', 'vnd_nat_intermun_cdf', 'vnd_nat_intermun_des')} />
                        <Des value={ad.vnd_nat_intermun_des} />
                      </Row>
                      <Row label="Nat.Tr.InterEsta:">
                        <Inp value={ad.vnd_nat_interesta} onChange={v => { a('vnd_nat_interesta', v); a('vnd_nat_interesta_des', '') }}
                          onBlurLookup={() => buscarNaturezaPorCod(ad.vnd_nat_interesta, 'vnd_nat_interesta_cdf', 'vnd_nat_interesta_des')} style={inpCod} placeholder="Código" />
                        <Inp value={ad.vnd_nat_interesta_cdf} onChange={v => { a('vnd_nat_interesta_cdf', v); a('vnd_nat_interesta_des', '') }}
                          onBlurLookup={() => buscarNaturezaPorCdf(ad.vnd_nat_interesta_cdf, 'vnd_nat_interesta', 'vnd_nat_interesta_des')}
                          style={{ ...inpCod, background: '#fef3c7', borderColor: '#f59e0b' }} placeholder="CFOP" />
                        <BtnBuscar onClick={() => abrirSeletorNatureza('vnd_nat_interesta', 'vnd_nat_interesta_cdf', 'vnd_nat_interesta_des')} />
                        <Des value={ad.vnd_nat_interesta_des} />
                      </Row>
                      <Row label="Cód. Observação:">
                        <Inp value={ad.vnd_cod_obs} onChange={v => { a('vnd_cod_obs', v); a('vnd_cod_obs_des', '') }}
                          onBlurLookup={() => buscarObservacao(ad.vnd_cod_obs, 'vnd_cod_obs_des')} style={inpCod} />
                        <BtnBuscar onClick={() => abrirSeletorObservacao('vnd_cod_obs', 'vnd_cod_obs_des')} />
                        <Des value={ad.vnd_cod_obs_des} />
                      </Row>
                      <Row label="Condição Pagamento:">
                        <Inp value={ad.vnd_cond_pgto} onChange={v => { a('vnd_cond_pgto', v); a('vnd_cond_pgto_des', '') }}
                          onBlurLookup={() => buscarCondPgto(ad.vnd_cond_pgto, 'vnd_cond_pgto_des')} style={inpCod} />
                        <BtnBuscar onClick={() => abrirSeletorCondPgto('vnd_cond_pgto', 'vnd_cond_pgto_des')} />
                        <Des value={ad.vnd_cond_pgto_des} />
                      </Row>
                    </div>
                  )}

                  {/* DOCUMENTAÇÃO */}
                  {abaAd === 'documentacao' && (
                    <div>
                      <Row label="Data Nascimento:">
                        <InpData value={ad.doc_nascimento} onChange={v => a('doc_nascimento', v)} style={inpMd} />
                      </Row>
                      <Row label="Número do RG:">
                        <Inp value={ad.doc_rg} onChange={v => a('doc_rg', v)} style={inpMd} />
                      </Row>
                      <Row label="Número Carteira:">
                        <Inp value={ad.doc_carteira} onChange={v => a('doc_carteira', v)} style={inpMd} />
                      </Row>
                      <Row label="Data Expedição:">
                        <InpData value={ad.doc_expedicao} onChange={v => a('doc_expedicao', v)} style={inpMd} />
                      </Row>
                      <Row label="Órgão Emissor:">
                        <Inp value={ad.doc_orgao} onChange={v => a('doc_orgao', v)} style={inpMd} />
                      </Row>
                      <Row label="RNTRC:">
                        <Inp value={ad.doc_rntrc} onChange={v => a('doc_rntrc', v)} style={inpMd} />
                      </Row>
                    </div>
                  )}

                  {/* E-MAILS */}
                  {abaAd === 'emails' && (
                    <div>
                      {([
                        ['eml_01', 'NF-e',   'E-mail 01:'],
                        ['eml_02', 'NFS-e',  'E-mail 02:'],
                        ['eml_03', 'Cte-Os', 'E-mail 03:'],
                        ['eml_04', 'Cópia',  'E-mail 04:'],
                      ] as [keyof AdState, string, string][]).map(([fld, tipoLabel, lbl]) => (
                        <Row key={fld} label={lbl}>
                          <Inp value={ad[fld] as string} onChange={v => a(fld, v)} style={{ flex: 1 }} placeholder="email@exemplo.com" />
                          <span style={{
                            fontSize: '0.75rem', fontWeight: 600, color: '#6b7280',
                            background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 4,
                            padding: '0.3rem 0.6rem', width: 60, textAlign: 'center', flexShrink: 0,
                          }}>{tipoLabel}</span>
                        </Row>
                      ))}
                      <Row label="E-mail Cópia 2:">
                        <Inp value={ad.eml_copia2} onChange={v => a('eml_copia2', v)} style={{ flex: 1, background: '#fefce8', borderColor: '#fde047' }} placeholder="email@exemplo.com" />
                      </Row>
                      <Row label="E-mail Cópia 3:">
                        <Inp value={ad.eml_copia3} onChange={v => a('eml_copia3', v)} style={{ flex: 1, background: '#fefce8', borderColor: '#fde047' }} placeholder="email@exemplo.com" />
                      </Row>
                      <Row label="E-mail Cópia 4:">
                        <Inp value={ad.eml_copia4} onChange={v => a('eml_copia4', v)} style={{ flex: 1, background: '#fefce8', borderColor: '#fde047' }} placeholder="email@exemplo.com" />
                      </Row>
                      <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.75rem' }}>
                        O tipo ao lado indica automaticamente se o destinatário recebe NF-e, NFS-e, Cte-Os ou apenas Cópia via e-mail.
                      </p>
                    </div>
                  )}

                  {/* BLOQUEIO */}
                  {abaAd === 'bloqueio' && (
                    <div>
                      <Row label="Data do Bloqueio:">
                        <InpData value={ad.blq_data} onChange={v => a('blq_data', v)} style={inpMd} />
                        <span style={{ fontSize: '0.78rem', color: '#6b7280' }}>(data nula para cliente desbloqueado)</span>
                      </Row>
                      <div style={{ marginTop: '0.75rem' }}>
                        <label style={{ fontSize: '0.8rem', color: '#374151', display: 'block', marginBottom: '0.35rem' }}>Descrição/Motivo:</label>
                        <textarea value={ad.blq_motivo} onChange={e => a('blq_motivo', e.target.value)} rows={4} maxLength={400}
                          style={{ width: '100%', boxSizing: 'border-box', fontSize: '0.82rem', padding: '0.5rem 0.6rem', border: '1px solid #d1d5db', borderRadius: 4, resize: 'vertical', fontFamily: 'inherit' }} />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* ── Contas Bancárias ── */}
              {aba === 'bancarias' && (
                <div>
                  <Row label="Cód. Participante:">
                    <Inp value={formatarDoc(form.cli_mat)} onChange={() => {}} style={{ width: 160, background: '#f3f4f6' }} />
                    <Des value={form.cli_nom} />
                  </Row>
                  <div style={{ height: 1, background: '#e5e7eb', margin: '0.75rem 0 1rem' }} />
                  <Row label="Seq. do Cadastro:">
                    <Inp value={bco.bco_seq} onChange={v => bc('bco_seq', v)} style={inpSm} />
                  </Row>
                  <Row label="Código do Banco:">
                    <Inp value={bco.bco_codigo} onChange={v => { bc('bco_codigo', v); bc('bco_codigo_des', '') }}
                      onBlurLookup={() => buscarBanco(bco.bco_codigo)} style={inpCod} />
                    <BtnBuscar onClick={() => setSeletorBanco(true)} />
                    <Des value={bco.bco_codigo_des} />
                  </Row>
                  <Row label="Nro. Agência/DV:">
                    <Inp value={bco.bco_agencia} onChange={v => bc('bco_agencia', v)} style={inpCod} />
                    <span style={{ fontSize: '0.82rem' }}>-</span>
                    <Inp value={bco.bco_agencia_dv} onChange={v => bc('bco_agencia_dv', v)} style={{ width: 40 }} />
                  </Row>
                  <Row label="Nro. da Conta/DV:">
                    <Inp value={bco.bco_conta} onChange={v => bc('bco_conta', v)} style={inpMd} />
                    <span style={{ fontSize: '0.82rem' }}>-</span>
                    <Inp value={bco.bco_conta_dv} onChange={v => bc('bco_conta_dv', v)} style={{ width: 40 }} />
                    <span style={{ fontSize: '0.8rem', color: '#374151', marginLeft: '0.5rem' }}>DAC:</span>
                    <Inp value={bco.bco_dac} onChange={v => bc('bco_dac', v)} style={{ width: 40 }} />
                  </Row>
                  <Row label="Tipo da Conta:">
                    <select className="input" value={bco.bco_tipo} onChange={e => bc('bco_tipo', e.target.value)} style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', width: 200 }}>
                      <option value="CC">CC - Conta Corrente</option>
                      <option value="CP">CP - Conta Poupança</option>
                    </select>
                  </Row>
                  <Row label="CPF/CNPJ Favorecido:">
                    <Inp value={bco.bco_favorecido_doc} onChange={v => bc('bco_favorecido_doc', v)} style={inpMd} />
                  </Row>
                  <Row label="Nome do Favorecido:">
                    <Inp value={bco.bco_favorecido_nome} onChange={v => bc('bco_favorecido_nome', v)} style={{ width: '50%' }} />
                  </Row>
                  <Row label="Cidade Agência/Conta:">
                    <Inp value={bco.bco_cidade} onChange={v => bc('bco_cidade', v)} style={{ width: '30%' }} />
                    <span style={{ fontSize: '0.8rem', color: '#374151', marginLeft: '0.5rem' }}>UF:</span>
                    <select className="input" value={bco.bco_uf} onChange={e => bc('bco_uf', e.target.value)} style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', width: 70 }}>
                      <option value="">--</option>
                      {UFS.map(u => <option key={u} value={u}>{u}</option>)}
                    </select>
                  </Row>
                  <Row label="É Conta Conjunta?">
                    <select className="input" value={bco.bco_conjunta} onChange={e => bc('bco_conjunta', e.target.value)} style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', width: 100 }}>
                      <option value="N">Não</option>
                      <option value="S">Sim</option>
                    </select>
                  </Row>
                  <Row label="Forma Pagamento:">
                    <select className="input" value={bco.bco_forma_pagamento} onChange={e => bc('bco_forma_pagamento', e.target.value)} style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', width: 200 }}>
                      <option value="N">DOC/TED, Depósito</option>
                      <option value="B">Boleto Bancário</option>
                    </select>
                  </Row>
                  <Row label="Cta. Preferencial:">
                    <select className="input" value={bco.bco_preferencial} onChange={e => bc('bco_preferencial', e.target.value)} style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', width: 100 }}>
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </Row>
                </div>
              )}

              {/* ── Portadores ── */}
              {aba === 'portadores' && (
                <div>
                  <Row label="Cadastro:">
                    <Inp value={formatarDoc(form.cli_mat)} onChange={() => {}} style={{ width: 160, background: '#f3f4f6' }} />
                    <Des value={form.cli_nom} />
                  </Row>
                  <div style={{ height: 1, background: '#e5e7eb', margin: '0.75rem 0 1rem' }} />
                  <Row label="Portador:">
                    <Inp value={por.por_codigo} onChange={v => { pc('por_codigo', v); pc('por_codigo_des', '') }}
                      onBlurLookup={() => buscarPortador(por.por_codigo)} style={inpCod} />
                    <BtnBuscar onClick={() => setSeletorPortador(true)} />
                    <Des value={por.por_codigo_des} />
                  </Row>
                  <Row label="Preferência:">
                    <select className="input" value={por.por_preferencial} onChange={e => pc('por_preferencial', e.target.value)} style={{ fontSize: '0.82rem', padding: '0.35rem 0.6rem', width: 100 }}>
                      <option value="N">Não</option>
                      <option value="S">Sim</option>
                    </select>
                  </Row>
                </div>
              )}

              {erro && <div className="login-error" style={{ marginTop: '1rem' }}>{erro}</div>}
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModal(false)}>Cancelar</button>
              <button className="btn btn-orange" onClick={salvar} disabled={salvando}>
                {salvando ? 'Salvando...' : 'Salvar'}
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Seletor genérico (Compras/Vendas) */}
      {seletor && (
        <SeletorModal titulo={seletor.titulo} endpoint={seletor.endpoint} codigoKey={seletor.codigoKey} descKey={seletor.descKey}
          extraKey={seletor.extraKey} extraLabel={seletor.extraLabel}
          onFechar={() => setSeletor(null)}
          onSelecionar={(cod, des, extra) => {
            a(seletor.codCampo, cod)
            if (seletor.cdfCampo) a(seletor.cdfCampo, extra || '')
            a(seletor.desCampo, des)
            setSeletor(null)
          }} />
      )}

      {seletorBanco && (
        <SeletorModal titulo="Bancos" endpoint="/erp/bancos" codigoKey="ban_cod" descKey="ban_des"
          onFechar={() => setSeletorBanco(false)}
          onSelecionar={(cod, des) => { bc('bco_codigo', cod); bc('bco_codigo_des', des); setSeletorBanco(false) }} />
      )}

      {seletorPortador && (
        <SeletorModal titulo="Portadores" endpoint="/erp/portadores" codigoKey="por_cod" descKey="por_des"
          onFechar={() => setSeletorPortador(false)}
          onSelecionar={(cod, des) => { pc('por_codigo', cod); pc('por_codigo_des', des); setSeletorPortador(false) }} />
      )}

      {/* Gerar Relatório */}
      {modalRelatorio && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModalRelatorio(false)}>
          <div className="modal-box" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{relCliente ? 'Gerar Relatório do Cliente' : 'Gerar Relatório de Clientes/Fornecedores'}</h2>
              <button className="modal-fechar" onClick={() => setModalRelatorio(false)}>✕</button>
            </div>
            <div className="modal-corpo">
              {relCliente && (
                <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 4, padding: '0.5rem 0.75rem', marginBottom: '1rem', fontSize: '0.85rem', color: '#1a6ea8', fontWeight: 600 }}>
                  {relCliente.cli_nom}
                </div>
              )}
              <Row label="Formato:">
                <select className="input" value={relFormato} onChange={e => setRelFormato(e.target.value as any)} style={{ fontSize: '0.85rem', padding: '0.4rem 0.6rem', flex: 1 }}>
                  <option value="pdf">PDF</option>
                  <option value="excel">Excel (.xlsx)</option>
                </select>
              </Row>
              <Row label="Tipo de Relatório:">
                <select className="input" value={relTipo} onChange={e => setRelTipo(e.target.value as any)} style={{ fontSize: '0.85rem', padding: '0.4rem 0.6rem', flex: 1 }}>
                  <option value="sintetico">Sintético</option>
                  <option value="analitico">Analítico</option>
                </select>
              </Row>
              <p style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: '-0.4rem', marginBottom: '0.6rem' }}>
                {relTipo === 'sintetico' ? 'Informações básicas (código, nome, cidade, telefone).' : 'Completo, com endereço, contato e dados bancários.'}
              </p>
              {!relCliente && (
                <>
                  <Row label="Status:">
                    <select className="input" value={relStatus} onChange={e => setRelStatus(e.target.value as any)} style={{ fontSize: '0.85rem', padding: '0.4rem 0.6rem', flex: 1 }}>
                      <option value="todos">Todos</option>
                      <option value="ativo">Somente Ativos</option>
                      <option value="baixado">Somente Baixados</option>
                    </select>
                  </Row>
                  <Row label="Tipo de Cadastro:">
                    <select className="input" value={relCadastro} onChange={e => setRelCadastro(e.target.value)} style={{ fontSize: '0.85rem', padding: '0.4rem 0.6rem', flex: 1 }}>
                      {TIPOS_CADASTRO.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                    </select>
                  </Row>
                </>
              )}
              <p style={{ fontSize: '0.78rem', color: '#6b7280', marginTop: '0.75rem' }}>
                {relCliente
                  ? 'O relatório trará apenas os dados deste cliente.'
                  : 'O relatório considera todos os registros do banco de dados que atendem aos filtros acima (independente do que está digitado na busca da tela).'}
              </p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModalRelatorio(false)}>Cancelar</button>
              <button className="btn btn-orange" onClick={gerarRelatorio}>{relFormato === 'excel' ? 'Gerar Excel' : 'Gerar PDF'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmação exclusão */}
      {confirmarExcluir !== null && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setConfirmarExcluir(null)}>
          <div className="modal-box" style={{ maxWidth: 380 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Confirmar exclusão</h2>
              <button className="modal-fechar" onClick={() => setConfirmarExcluir(null)}>✕</button>
            </div>
            <div className="modal-corpo">
              <p style={{ fontSize: '0.9rem' }}>Deseja excluir o cadastro <strong>{confirmarExcluir.cli_nom}</strong> (código {confirmarExcluir.cli_cod})? Esta ação não pode ser desfeita.</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setConfirmarExcluir(null)}>Cancelar</button>
              <button className="btn btn-danger" onClick={() => excluir(confirmarExcluir!)}>Excluir</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
